<app-carousel [loading]="!products">
  <ng-container *ngIf="products && products.length > 0">
    <lp-product-card
      *ngFor="let product of products"
      [product]="product"
      [showIsFavorite]="isDesktop ? showIsFavorite : false"
      [showDiscount]="isDesktop"
      [size]="isDesktop ? 'l' : 'm'"
    ></lp-product-card>
  </ng-container>
</app-carousel>
